import AdminLayout from "../../layout/admin/AdminLayout";
import Automation from "../../view/admin/automation/Automation";
import BlogCategories from "../../view/admin/blog/Categories";
import CreateBlog from "../../view/admin/blog/CreateBlog";
import EditBlog from "../../view/admin/blog/EditBlog";
import ViewBlogList from "../../view/admin/blog/ViewBlogList";
import AddCompany from "../../view/admin/company/AddCompany";
import CompanyList from "../../view/admin/company/CompanyList";
import EditCompany from "../../view/admin/company/EditCompany";
import Coupon from "../../view/admin/coupon/Coupon";
import Dashboard from "../../view/admin/dashboard/Dashboard";
import Error from "../../view/admin/error/Error";
import FileManager from "../../view/admin/filemanager/FileManager";
import AddHotel from "../../view/admin/hotel/AddHotel";
import DuplicateHotel from "../../view/admin/hotel/DuplicateHotel";
import EditHotel from "../../view/admin/hotel/EditHotel";
import Facilities from "../../view/admin/hotel/facility/Facilities";
import HotelList from "../../view/admin/hotel/HotelList";
import AddRoom from "../../view/admin/hotel/room/AddRoom";
import AvailableHotel from "../../view/admin/hotel/room/AvailableHotel";
import DuplicateRoom from "../../view/admin/hotel/room/DuplicateRoom";
import EditRoom from "../../view/admin/hotel/room/EditRoom";
import RoomList from "../../view/admin/hotel/room/RoomList";
import ViewHotel from "../../view/admin/hotel/ViewHotel";
import AddOffers from "../../view/admin/offers/AddOffers";
import EditOffers from "../../view/admin/offers/EditOffers";
import OfferList from "../../view/admin/offers/OfferList";
import AddHotelBooking from "../../view/admin/orders/AddHotelBooking";
import HotelOrders from "../../view/admin/orders/HotelOrders";
import TourOrders from "../../view/admin/orders/TourOrders";
import HomePage from "../../view/admin/page/HomePage";
import HotelBookingReport from "../../view/admin/report/HotelBookingReport";
import TourBookingReport from "../../view/admin/report/TourBookingReport";
import ViewTemplates from "../../view/admin/templates/ViewTemplates";
import CreateTour from "../../view/admin/tour/CreateTour";
import EditTour from "../../view/admin/tour/EditTour";
import TourList from "../../view/admin/tour/TourList";
import AdminList from "../../view/admin/user/AdminList";
import UserList from "../../view/admin/user/UserList";
import Location from "../../view/admin/location/Location";
import AdminProtectedRoute from "./adminProtectedRoute";
import OrderDetails from "../../view/admin/orders/OderDetails";
import AdminChatInbox from "../../view/admin/automation/Adminchatinbox";

const adminRouter = {
  path: "/admin",
  element: (
    <AdminProtectedRoute>
      <AdminLayout />
    </AdminProtectedRoute>
  ),
  children: [
    {
      path: "/admin/dashboard",
      element: (
        <AdminProtectedRoute>
          <Dashboard />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/templates",
      element: (
        <AdminProtectedRoute>
          <ViewTemplates />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/file-manager",
      element: (
        <AdminProtectedRoute>
          <FileManager />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/*",
      element: (
        <AdminProtectedRoute>
          <Error />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/blogs",
      element: (
        <AdminProtectedRoute>
          <ViewBlogList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/blog/create",
      element: (
        <AdminProtectedRoute>
          <CreateBlog />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/blog/edit/:id",
      element: (
        <AdminProtectedRoute>
          <EditBlog />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/blog/categories",
      element: (
        <AdminProtectedRoute>
          <BlogCategories />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/companies",
      element: (
        <AdminProtectedRoute>
          <CompanyList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/company/create",
      element: (
        <AdminProtectedRoute>
          <AddCompany />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/company/edit/:id",
      element: (
        <AdminProtectedRoute>
          <EditCompany />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/hotel/facilities",
      element: (
        <AdminProtectedRoute>
          <Facilities />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/hotel/create",
      element: (
        <AdminProtectedRoute>
          <AddHotel />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/hotels",
      element: (
        <AdminProtectedRoute>
          <HotelList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/hotel/duplicate",
      element: (
        <AdminProtectedRoute>
          <DuplicateHotel />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/hotel/edit/:id",
      element: (
        <AdminProtectedRoute>
          <EditHotel />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/hotel/view/:id",
      element: (
        <AdminProtectedRoute>
          <ViewHotel />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/rooms",
      element: (
        <AdminProtectedRoute>
          <RoomList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/rooms/available/:id",
      element: (
        <AdminProtectedRoute>
          <AvailableHotel />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/room/create",
      element: (
        <AdminProtectedRoute>
          <AddRoom />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/room/duplicate",
      element: (
        <AdminProtectedRoute>
          <DuplicateRoom />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/room/edit/:id",
      element: (
        <AdminProtectedRoute>
          <EditRoom />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/coupons",
      element: (
        <AdminProtectedRoute>
          <Coupon />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/offers",
      element: (
        <AdminProtectedRoute>
          <OfferList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/offer/create",
      element: (
        <AdminProtectedRoute>
          <AddOffers />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/offer/edit/:id",
      element: (
        <AdminProtectedRoute>
          <EditOffers />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/page/home",
      element: (
        <AdminProtectedRoute>
          <HomePage />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/tours",
      element: (
        <AdminProtectedRoute>
          <TourList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/tour/create",
      element: (
        <AdminProtectedRoute>
          <CreateTour />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/tour/edit/:id",
      element: (
        <AdminProtectedRoute>
          {" "}
          <EditTour />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/users",
      element: (
        <AdminProtectedRoute>
          <UserList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/user/admins",
      element: (
        <AdminProtectedRoute>
          <AdminList />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/order/hotels",
      element: (
        <AdminProtectedRoute>
          <HotelOrders />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/order/hotel/details/:id",
      element: (
        <AdminProtectedRoute>
          <OrderDetails />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/order/add",
      element: (
        <AdminProtectedRoute>
          <AddHotelBooking />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/order/tours",
      element: (
        <AdminProtectedRoute>
          <TourOrders />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/order/tours",
      element: (
        <AdminProtectedRoute>
          <TourOrders />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/report/hotels",
      element: (
        <AdminProtectedRoute>
          <HotelBookingReport />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/report/tours",
      element: (
        <AdminProtectedRoute>
          <TourBookingReport />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/automation/chat",
      element: (
        <AdminProtectedRoute>
          <Automation />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/automation/admin",
      element: (
        <AdminProtectedRoute>
          <AdminChatInbox />
        </AdminProtectedRoute>
      ),
    },
    {
      path: "/admin/location",
      element: (
        <AdminProtectedRoute>
          <Location />
        </AdminProtectedRoute>
      ),
    },
  ],
};

export default adminRouter;
